module.exports = {
      id: "cancel-usage",
      viewBox: "0 0 241.171 241.171",
      url: "/" + "sprite-e509a544a5c47560e0a2aa1e13829d5a.svg#cancel",
      toString: function () {
        return this.url;
      }
    }